import React from 'react'
import { Link } from 'react-router-dom'
import { LinkProps } from './Link.types'

const ArcTradeLink: React.FC<LinkProps> = ({ children, router, onClick }) => {
    const classNames = ['r-link']

    if (router) {
        return (
            <Link className={classNames.join(' ')} {...router}>
                {children}
            </Link>
        )
    }

    if (onClick) {
        return (
            <div className={classNames.join(' ')} onClick={onClick}>
                {children}
            </div>
        )
    }

    throw Error("Link: specify either a 'router' or 'onClick' prop")
}

export default ArcTradeLink
